import moment from 'moment';
import { createApi as coreCreateApi } from './core';
import { ShiftSchedule } from './scheduling.types';

declare const healConfig: any;

function createApi() {
  return coreCreateApi({ baseURL: healConfig.apiBaseUrl + '/eta' });
}

export function fetchShifts(date: string): Promise<ShiftSchedule> {
  date = moment(date).format('YYYY-MM-DD');
  return createApi()
    .then((api) => api.get<ShiftSchedule>('/getShiftsForDate', { date }))
    .then((r) => (r.ok && r.data ? r.data : Promise.reject(`Failed to get schedule for ${date}`)));
}

export function fetchSchedule(date: string, market_group: string): Promise<any> {
  return createApi()
    .then((api) => api.get<any>('/eta_pred', { query_type: 'schedule', market_group, date }))
    .then((r) => (r.ok && r.data ? r.data : Promise.reject(`Failed to get schedule for ${date}`)));
}

export function fetchExpedite(market_group: string, date: string, provider_id: string): Promise<string[]> {
  return createApi()
    .then((api) => api.get<any[]>('/expedite', { market_group, date, provider_id }))
    .then((r) => (r.ok ? r.data ?? [] : Promise.reject(`Failed to get expediter recommendations.`)));
}
